<template lang="html">
  <el-form
    :model="ruleForm"
    ref="ruleForm"
    label-width="100px"
    class="transport-require"
  >
    <div class="transport-require-box">
      <el-form-item label="期望车型" prop="expectTruckType">
        <el-input
          v-model="ruleForm.expectTruckType"
          placeholder="请输入期望车型"
        ></el-input>
      </el-form-item>
      <el-form-item label="期望车长" prop="expectTruckLength">
        <el-input
          v-model="ruleForm.expectTruckLength"
          placeholder="请输入期望车长"
        ></el-input>
      </el-form-item>
      <el-form-item label="货最长" prop="goodsLongest">
        <el-input
          v-model="ruleForm.goodsLongest"
          placeholder="请输入货最长"
        ></el-input>
      </el-form-item>
      <el-form-item label="货最宽" prop="goodsWidth">
        <el-input
          v-model="ruleForm.goodsWidth"
          placeholder="请输入货最宽"
        ></el-input>
      </el-form-item>
    </div>

    <el-form-item label="要求标签" prop="name" class="request-label">
      <div class="tags-wrapper">
        <span
          class="tag"
          v-for="(item, index) in tags"
          :key="index"
          :class="{ chosed: item.selected }"
          @click="doAdd(index)"
          >{{ item.text }}</span
        >
      </div>
    </el-form-item>
    <el-form-item label="运输备注" prop="notes">
      <el-input
        v-model="ruleForm.notes"
        type="textarea"
        placeholder="请输入运输备注"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { tags } from "@/views/personal/deliver/components/transportRequire/config";

export default {
  data() {
    return {
      ruleForm: {
        notes: "",
        expectTruckType: "",
        goodsLongest: "",
        goodsWidth: "",
        expectTruckLength: ""
      },
      tags: [
        {
          text: "当日达",
          selected: false
        },
        {
          text: "次日达",
          selected: false
        },
        {
          text: "车到就可提货",
          selected: false
        },
        {
          text: "有送货单",
          selected: false
        },
        {
          text: "仓库单子不可给客户",
          selected: false
        },
        {
          text: "盖雨布",
          selected: false
        },
        {
          text: "代换送货单",
          selected: false
        },
        {
          text: "货物弯曲、生锈联系后再装",
          selected: false
        },
        {
          text: "车到加工",
          selected: false
        },
        {
          text: "包车",
          selected: false
        },
        {
          text: "配货",
          selected: false
        },
        {
          text: "质保书卸货",
          selected: false
        }
      ]
    };
  },
  computed: {
    defaultOtherLabels() {
      let arr = [];
      this.tags.map(item => {
        if (item.selected) {
          arr.push(item.text);
        }
      });
      return arr;
    }
  },
  created() {},
  methods: {
    doAdd(index) {
      this.tags[index].selected = !this.tags[index].selected;
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss">
.transport-require {
  &-box {
    display: flex;
  }
  .tags-wrapper {
    display: inline-block;
    vertical-align: top;
    .tag {
      display: inline-block;
      color: #757575;
      font-size: 14px;
      padding: 0 10px;
      cursor: pointer;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      margin: 2px 5px;
      user-select: none;
      line-height: 34px;
      transition: all 0.2s;
      &.chosed {
        background-color: #00a7f7;
        color: white;
        border-color: #00a7f7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/transportRequire/index.vue